var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apex-chart',{attrs:{"width":"100%","type":"heatmap","options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }